module.exports = __webpack_public_path__ + "dd3851d985f0af0ee935ece28b80d79f.png";